export const ExternalRoutes = {
  login: () => {
    const path = `/auth/users/sign_in?return_to=${window.location.origin}/reporting` as const;
    return handleExternalRoutesInDevMode(path);
  }
};

const LOCAL_DEVELOPMENT_AUTH_DOMAIN = 'https://controlpanel.ogintegration.us';
function handleExternalRoutesInDevMode(path: string) {
  if (process.env.NODE_ENV === 'development') {
    // In development, relative paths resolve to ogov.me which doesn't support authentication.
    // Prepend the ogintegration.us domain to ensure auth redirects work correctly locally.
    return `${LOCAL_DEVELOPMENT_AUTH_DOMAIN}${path}`;
  }

  return path;
}
